module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"usageComparison.comparisontimeframe":"Comparison timeframe","usageComparison.currentperiodending":"Current period ending"}}')
  delete Component.options._Ctor
}
